<portal-link
  class="nav-link-container"
  [activeRoutes]="activeRoutes"
  [params]="params"
  [route]="route"
  [routerLinkActiveExact]="routeExact"
  (click)="emit()"
  classes="nav-link"
  routerLinkActive="active"
>
  <ng-container [ngTemplateOutlet]="content"></ng-container>
</portal-link>
